export default "__VITE_ASSET__BpV5r0od__"